import { useState } from 'react';
import api from '../utils/api';
import { useVpSnackbar } from '../vp-ui/hooks/useVpSnackbar';

export const useForceDownload = () => {
  const { addSnackbarError } = useVpSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [hasError, setHasError] = useState(false);

  const forceDownload = async (url, fileName) => {
    try {
      setIsLoading(true);
      setHasError(false);
      setIsSuccess(false);
      const blob = await api.get(url, {
        headers: { 'Content-Type': 'application/octet-stream' },
        withCredentials: false,
        responseType: 'blob'
      });

      const fileUrl = window.URL.createObjectURL(blob);
      const tag = document.createElement('a');
      tag.href = fileUrl;
      tag.download = fileName;
      document.body.appendChild(tag);
      tag.click();
      document.body.removeChild(tag);
      setIsSuccess(true);
    } catch (error) {
      addSnackbarError({ title: '', message: 'Error attempting to download attachment' });
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isSuccess,
    hasError,
    forceDownload
  };
};



// WEBPACK FOOTER //
// ./src/hooks/useForceDownload.js